import './forms.css'
import React from 'react'
import { db } from '../services/firebase'
import { Field, reduxForm } from 'redux-form'
import { FormGroup, Row, Col } from 'react-bootstrap'
import { renderField, renderSelect, renderTextarea } from './_fieldRenderer'

class ProductForm extends React.Component {

    state = {
        loading: false,
        productsLines: []
    }

    componentDidMount() {
        this._fetchProductsLines()
    }

    render() {
        const { productsLines, loading } = this.state
        const { handleSubmit } = this.props
        return (
            <form onSubmit={handleSubmit}>
                <Row>
                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name='model'
                                type='text'
                                component={renderField}
                                label='Modelo'
                                placeholder='Modelo'
                            />
                        </FormGroup>
                    </Col>

                    <Col md={3}>
                        <FormGroup>
                            <Field
                                name='productLine'
                                component={renderSelect}
                                options={productsLines}
                                label='Linha'
                                disabled={loading}
                                placeholder={'Selecione'}
                            />
                        </FormGroup>
                    </Col>

                    <Col md={3}>
                        <FormGroup>
                            <Field
                                name='active'
                                component={renderSelect}
                                options={[
                                    { value: true, label: 'Ativo' },
                                    { value: false, label: 'Fora de Linha' }
                                ]}
                                label='Status'
                                placeholder={'Selecione'}
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md={12}>
                        <FormGroup>
                            <Field
                                name='description'
                                component={renderTextarea}
                                label='Descrição'
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </form >
        )
    }

    _fetchProductsLines = () => {
        this.setState({ loading: true })
        const productsLines = []
        db.collection('products_lines').get()
            .then(snapshot => {
                if (!snapshot.empty) {
                    snapshot.forEach(s => productsLines.push({ value: s.id, label: s.data().name }))
                    this.setState({ productsLines, loading: false })
                }
            })
    }

}

const validate = values => {
    const errors = {}
    if (!values.model) { errors.model = 'Obrigatório' }
    if (!values.productLine) { errors.productLine = 'Obrigatório' }
    if (!values.description) { errors.description = 'Obrigatório' }
    if (!values.active) { errors.active = 'Obrigatório' }

    return errors
}

ProductForm = reduxForm({ form: 'ProductForm', validate })(ProductForm)
export default ProductForm



// WEBPACK FOOTER //
// ./src/forms/ProductForm.jsx